import { createSlice } from '@reduxjs/toolkit';

import { RootState } from 'src/redux/index';
import { getCurrencySymbols } from 'src/redux/actions/appState';
import type { CandidatePostState } from '../types';
import { getJobRoleList, verifyCandidateOTP } from '../actions';

const initialState: CandidatePostState = {
  jobRoleListLoading: false,
  skillListLoading: false,
  validateOtp: false,
};

/* eslint-disable no-param-reassign */
const candidatePostSlice = createSlice({
  name: 'candidatePost',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getJobRoleList.pending, (state) => {
      state.jobRoleListLoading = true;
    });
    builder.addCase(getJobRoleList.fulfilled, (state, action) => {
      state.jobRoleList = action.payload;
      state.jobRoleListLoading = false;
    });
    builder.addCase(getJobRoleList.rejected, (state) => {
      state.jobRoleListLoading = false;
    });
    builder.addCase(verifyCandidateOTP.fulfilled, (state, action) => {
      state.validateOtp = action.payload.status === 200;
      state.validateOtpData = action.payload.data;
    });
    builder.addCase(verifyCandidateOTP.rejected, (state) => {
      state.validateOtp = false;
    });
    builder.addCase(getCurrencySymbols.fulfilled, (state, action) => {
      state.currencySymbols = action.payload;
    });
  },
});
/* eslint-enable no-param-reassign */

const { reducer } = candidatePostSlice;

export const candidateOnboardingSelector = (state: RootState) =>
  state.candidateOnboarding;
export const userDetailSelector = (state: RootState) => state.auth.user;
export const currencySymbolsSelector = (state: RootState) =>
  state.candidateOnboarding.currencySymbols;

export default reducer;
